import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { Ng4FilesModule } from 'angular4-files-upload';
import { StatusComponent } from './status/status.component';
import { StatusListComponent } from './status-list/status-list.component';

//import { UserListComponent } from './user-list/user-list.component';
//import { UserEditComponent } from './user-edit/user-edit.component';
//import { UserNewComponent } from './user-new/user-new.component';

import { StatusRoutingModule } from './status-routing.module';

import { StatusService } from './status.service';
import { SharedModule } from '../../shared/shared.module';
import { NgxSmartModalModule, NgxSmartModalService } from 'ngx-smart-modal';

//Spinner
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSpinnerService } from 'ngx-spinner';
import { StatusEditComponent } from './status-edit/status-edit.component';
import { StatusNewComponent } from './status-new/status-new.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    SharedModule,
    StatusRoutingModule,
    Ng4FilesModule,
    NgxSpinnerModule
  ],
  declarations: [
    StatusComponent,
    StatusListComponent,
    StatusEditComponent,
    StatusNewComponent
  ],
  providers: [
    StatusService,
    NgxSpinnerService
  ]
})
export class StatusModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/status/status.module.ts